export const IconLinkedin40: {
  name: 'icon_linkedin_40-809029dba2db'
} = {
  name: 'icon_linkedin_40-809029dba2db'
}
